import { useCallback } from 'react';
import { useSelector } from 'react-redux';
// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { NonEmptyArray } from 'packages/JsonQuery';
import { useFilterChangeCallback } from 'shared/hooks/useFilterChangeCallback';
import { selectMortgageFastFilterOptions } from 'shared/selectors/advancedFilters/mortgagePromoSearchType/selectMortgageFastFilterOptions';
import { selectMortgagePromoSearchTypeValue } from 'shared/selectors/advancedFilters/mortgagePromoSearchType/selectMortgagePromoSearchTypeValue';
import { selectPromoSearchTypes as selectAllPromoSearchTypeValues } from 'shared/selectors/jsonQuery';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';
import { getPromoSearchFilterValuesByType } from 'shared/utils/promoSearchTypes';
import {
  getSubsidizedMortgageModifierValue,
  removeSubsidizedMortgageFromValues,
} from 'shared/containers/AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers/MortgagePromoSearchTypeContainer/utils';
import { FILTER_KEY } from '../constants';

export const useMortgageTypeFilter = () => {
  const options = useSelector(selectMortgageFastFilterOptions);
  const value = useSelector(selectMortgagePromoSearchTypeValue);
  const allPromoSearchTypeValues = useSelector(selectAllPromoSearchTypeValues);
  const promoSearchTypes = useSelector(selectPromoSearchTypes);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (newValue: NonEmptyArray<string> | string | null | undefined) => {
      let _value: NonEmptyArray<string> | null = null;

      /* istanbul ignore next */
      if (Array.isArray(newValue)) {
        _value = newValue;
      } else if (!newValue) {
        _value = null;
      } else {
        _value = [newValue];
      }

      onChange(
        {
          action: 'setIsSubsidisedMortgage',
          arguments: [getSubsidizedMortgageModifierValue(_value)],
        },
        {
          action: 'setPromoSearchTypes',
          arguments: [
            {
              allValues: allPromoSearchTypeValues,
              newValues: removeSubsidizedMortgageFromValues(_value),
              availableFilterValues: getPromoSearchFilterValuesByType('mortgage', promoSearchTypes),
            },
          ],
        },
      );
    },
    [allPromoSearchTypeValues, onChange, promoSearchTypes],
  );

  return {
    options,
    value,
    onFilterChange: handleChange,
  };
};
